export const ShareConfig = {
  btnSize: 64,
  startAngle: 0,
  endAngle: 315,
  outerRadius: 110,
};
